import { app } from '../../app.module'
app
  // インプレッションの反応数グラフの表示
  .directive('accountImpression', () => {
    return {
      restrict: 'E',
      template: require('./account-impression.pug')(),
    }
  })
